<div class="center">
<svg-icon [icon]="cell.row ? iconToUse : ''"
            [class.error]="cell.row"
            class="tiny"></svg-icon>
</div>